import { Plus } from 'lucide-react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { Header } from '@/components/Header';
import { Sidebar } from '@/components/Sidebar';
import { Button } from '@/components/ui/button';

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/listings': 'Listings',
  '/contractors': 'Contractors',
  '/lenders': 'Lenders',
  '/settings': 'Settings',
};

const pageActions: Record<string, { label: string; route: string }> = {
  '/listings': { label: 'Create Listing', route: '/listings/new' },
  '/contractors': { label: 'Create Contractor', route: '/contractors/new' },
  '/lenders': { label: 'Create Lender', route: '/lenders/new' },
};

export function DashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = pageTitles[location.pathname] || 'Admin Dashboard';

  // Render action button based on current page
  const renderPageActions = () => {
    const action = pageActions[location.pathname];
    if (action) {
      return (
        <Button
          onClick={() => navigate(action.route)}
          className="h-[48px] rounded-[100px] bg-[#191919] px-[24px] font-semibold text-white hover:bg-[#2a2a2a]"
        >
          <Plus size={20} className="mr-[8px]" />
          {action.label}
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="flex h-screen bg-[#fefcf6]">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={pageTitle} actions={renderPageActions()} />
        <div className="flex-1 overflow-y-auto">
          <div className="th-container">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
